import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import Loadercomponent from "../../../../Componets/Loader";
import { get_ap_report } from "../../../../Controllers/Accounting/Services/ApReport";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Accounting/ReportEntry/APReport/tables";
import headers from "../../../../Data/Tables/Accounting/ReportEntry/APReport/headers";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Button, Modal, Table as AntTable, Tag } from "antd";
import { EyeOutlined, FileOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const ApReportTable = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });
  
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [supplierPOS, setSupplierPOS] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  
  const navigate = useNavigate();

  const paginationdata = (data) => {
    let headerdata = {};
    header?.components?.map((value) => {
      headerdata[value.name] = value.value;
    });
    fetchData({
      ...data,
      date: headerdata?.date,
      supplier: headerdata?.supplier,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;
    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      let from, to;
      if (tabledata?.date?.start && tabledata?.date?.end) {
        from = dayjs(tabledata.date.start).format("YYYY-MM-DD");
        to = dayjs(tabledata.date.end).format("YYYY-MM-DD");
      }

      const response = await get_ap_report({
        from: from,
        to: to,
        supplier: tabledata?.supplier,
      });

      if (response?.success) {
        const apData = response.data || [];

        const tableBody = apData.map((item, index) => ({
          key: item.supplier_id || index,
          "Supplier": (
            <div>
              <div className="font-semibold">{item.supplier_name}</div>
              <div className="text-sm text-gray-500">{item.supplier_phone || "No Phone"}</div>
            </div>
          ),
          "Total Payable": (
            <span className="font-semibold text-blue-600">
              {parseFloat(item.total_payable || 0).toFixed(3)}
            </span>
          ),
          "Outstanding": (
            <span className="font-semibold text-red-600">
              {parseFloat(item.outstanding || 0).toFixed(3)}
            </span>
          ),
          "0-30 Days": parseFloat(item.age_0_30 || 0).toFixed(3),
          "31-60 Days": parseFloat(item.age_31_60 || 0).toFixed(3),
          "61-90 Days": parseFloat(item.age_61_90 || 0).toFixed(3),
          "90+ Days": (
            <span className={item.age_90_plus > 0 ? "text-red-600 font-semibold" : ""}>
              {parseFloat(item.age_90_plus || 0).toFixed(3)}
            </span>
          ),
          "PO Count": (
            <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs">
              {item.po_count || 0}
            </span>
          ),
          "Action": (
            <button
              onClick={() => handleViewSupplier(item)}
              className="px-3 py-1 rounded text-sm bg-blue-600 text-white hover:bg-blue-700 flex items-center gap-1"
            >
              <EyeOutlined /> View
            </button>
          ),
        }));

        setBody(tableBody);

        setPagination({
          currentPage: 1,
          totalCount: apData.length,
          totalPages: Math.ceil(apData.length / 10),
        });

        setLoader(false);
      } else {
        setLoader(false);
        toast.error("Failed to load AP report data");
      }
    } catch (error) {
      setLoader(false);
      console.error("Failed to load AP report:", error.message);
      toast.error(error.message);
    }
  };

  const handleViewSupplier = (supplier) => {
    setSelectedSupplier(supplier);
    fetchSupplierPOs(supplier.supplier_id);
    setModalVisible(true);
  };

  const fetchSupplierPOs = async (supplierId) => {
    setModalLoading(true);
    try {
      const response = await get_ap_report({
        supplier_id: supplierId,
        include_pos: true,
      });

      if (response?.success) {
        setSupplierPOS(response.pos_data || []);
      } else {
        toast.error("Failed to load purchase orders");
        setSupplierPOS([]);
      }
    } catch (error) {
      console.error("Error fetching supplier POs:", error);
      toast.error("Failed to load purchase orders");
      setSupplierPOS([]);
    } finally {
      setModalLoading(false);
    }
  };

  const handleRedirectToSupplier = (supplierId) => {
    navigate(`/app/suppliers/view/${supplierId}`);
    setModalVisible(false);
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    fetchData();
    headerReset();
  }, []);

  const exportPDF = async () => {
    try {
      const response = await get_ap_report({});

      if (response?.success) {
        const apData = response.data || [];
        const branch = response.branchInfo;

        const doc = new jsPDF();

        doc.setFontSize(16);
        const pageWidth = doc.internal.pageSize.getWidth();

        doc.setFontSize(20);
        doc.setFont("helvetica", "bold");
        doc.text(branch?.name || "Organization Name", pageWidth / 2, 20, {
          align: "center",
        });

        doc.setFontSize(11);
        doc.setFont("helvetica", "normal");
        doc.text(
          `${branch?.email || ""} | ${branch?.phone || ""} | ${branch?.country || ""}`,
          pageWidth / 2,
          27,
          { align: "center" }
        );

        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text("Accounts Payable Report", pageWidth / 2, 40, {
          align: "center",
        });

        autoTable(doc, {
          startY: 50,
          head: [
            [
              "Supplier",
              "Total Payable",
              "Outstanding",
              "0-30 Days",
              "31-60 Days",
              "61-90 Days",
              "90+ Days",
              "PO Count",
            ],
          ],
          body: apData.map((item) => [
            item.supplier_name,
            (item.total_payable || 0).toFixed(3),
            (item.outstanding || 0).toFixed(3),
            (item.age_0_30 || 0).toFixed(3),
            (item.age_31_60 || 0).toFixed(3),
            (item.age_61_90 || 0).toFixed(3),
            (item.age_90_plus || 0).toFixed(3),
            item.po_count || 0,
          ]),
          theme: "grid",
          styles: { fontSize: 9 },
          headStyles: { fillColor: [24, 144, 255] },
        });

        doc.save(`ap_report_${dayjs().format("YYYYMMDD")}.pdf`);
      }
    } catch (error) {
      console.error("Export PDF error:", error);
      toast.error("Failed to export PDF");
    }
  };

  const exportExcel = async () => {
    try {
      const response = await get_ap_report({});

      if (response?.success) {
        const apData = response.data || [];

        const rows = [];

        rows.push(["ACCOUNTS PAYABLE REPORT"]);
        rows.push([]);

        rows.push([
          "Supplier",
          "Supplier Phone",
          "Total Payable",
          "Outstanding",
          "0-30 Days",
          "31-60 Days",
          "61-90 Days",
          "90+ Days",
          "PO Count",
        ]);

        apData.forEach((item) => {
          rows.push([
            item.supplier_name || "",
            item.supplier_phone || "",
            Number(item.total_payable || 0).toFixed(3),
            Number(item.outstanding || 0).toFixed(3),
            Number(item.age_0_30 || 0).toFixed(3),
            Number(item.age_31_60 || 0).toFixed(3),
            Number(item.age_61_90 || 0).toFixed(3),
            Number(item.age_90_plus || 0).toFixed(3),
            item.po_count || 0,
          ]);
        });

        const content = rows.map((row) => row.join("\t")).join("\n");

        const blob = new Blob([content], {
          type: "application/vnd.ms-excel",
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `ap_report_${dayjs().format("YYYYMMDD")}.xls`;
        link.click();

        URL.revokeObjectURL(link.href);
      }
    } catch (error) {
      console.error("Export Excel error:", error);
      toast.error("Failed to export Excel");
    }
  };

  const poColumns = [
    {
      title: "PO Number",
      dataIndex: "number",
      key: "number",
      render: (text) => <span className="font-medium">#PO-{text}</span>,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => dayjs(date).format("DD-MMM-YYYY"),
    },
    {
      title: "Invoice",
      dataIndex: "invoice",
      key: "invoice",
      render: (text) => text || "-",
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      render: (value) => (
        <span className="font-semibold">{parseFloat(value || 0).toFixed(3)}</span>
      ),
    },
    {
      title: "Paid",
      dataIndex: "paid",
      key: "paid",
      render: (value) => parseFloat(value || 0).toFixed(3),
    },
    {
      title: "Payable",
      dataIndex: "payable",
      key: "payable",
      render: (value) => (
        <span className="text-red-600 font-semibold">
          {parseFloat(value || 0).toFixed(3)}
        </span>
      ),
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      key: "payment_status",
      render: (status) => {
        const statusMap = {
          0: { text: "Unpaid", color: "red" },
          1: { text: "Partial", color: "orange" },
          2: { text: "Paid", color: "green" },
        };
        const s = statusMap[status] || { text: "Unknown", color: "gray" };
        return <Tag color={s.color}>{s.text}</Tag>;
      },
    },
  ];

  return (
    <Header
      headers={header}
      setHeaders={setHeader}
      formdata={formdata}
      title="Accounts Payable Report"
    >
      <div className="flex gap-3 justify-end mt-4">
        <Button
          onClick={exportExcel}
          className="text-medium form-save-button"
          type="primary"
        >
          Export as Excel
        </Button>

        <Button
          onClick={exportPDF}
          className="text-medium form-save-button"
          type="primary"
        >
          Export as PDF
        </Button>
      </div>
      
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>

      <Modal
        title={
          <div className="flex items-center justify-between">
            <span>
              Purchase Orders - {selectedSupplier?.supplier_name || ""}
            </span>
            <Tag color="blue" className="ml-2">
              Total Payable: {parseFloat(selectedSupplier?.total_payable || 0).toFixed(3)}
            </Tag>
          </div>
        }
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          setSelectedSupplier(null);
          setSupplierPOS([]);
        }}
        width={1000}
        footer={[
          <Button
            key="redirect"
            type="primary"
            icon={<FileOutlined />}
            onClick={() => handleRedirectToSupplier(selectedSupplier?.supplier_id)}
            disabled={!selectedSupplier?.supplier_id}
          >
            View Supplier
          </Button>,
          <Button
            key="close"
            onClick={() => {
              setModalVisible(false);
              setSelectedSupplier(null);
              setSupplierPOS([]);
            }}
          >
            Close
          </Button>,
        ]}
      >
        <div className="mb-4">
          <div className="grid grid-cols-3 gap-4 mb-4 p-4 bg-gray-50 rounded-lg">
            <div>
              <div className="text-sm text-gray-500">Supplier</div>
              <div className="font-medium">{selectedSupplier?.supplier_name}</div>
            </div>
            <div>
              <div className="text-sm text-gray-500">Phone</div>
              <div className="font-medium">{selectedSupplier?.supplier_phone || "N/A"}</div>
            </div>
            <div>
              <div className="text-sm text-gray-500">Total POs</div>
              <div className="font-medium">{selectedSupplier?.po_count || 0}</div>
            </div>
          </div>
          
          <AntTable
            columns={poColumns}
            dataSource={supplierPOS}
            loading={modalLoading}
            pagination={{
              pageSize: 5,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} purchase orders`,
            }}
            rowKey="_id"
            size="small"
            className="border rounded-lg"
          />
          
          <div className="mt-4 p-4 bg-gray-50 rounded-lg">
            <div className="flex justify-between items-center">
              <span className="font-medium">Summary</span>
              <div className="flex gap-6">
                <div>
                  <span className="text-sm text-gray-500">Total POs:</span>
                  <span className="ml-2 font-semibold">{selectedSupplier?.po_count || 0}</span>
                </div>
                <div>
                  <span className="text-sm text-gray-500">Total Payable:</span>
                  <span className="ml-2 font-semibold text-blue-600">
                    {parseFloat(selectedSupplier?.total_payable || 0).toFixed(3)}
                  </span>
                </div>
                <div>
                  <span className="text-sm text-gray-500">Outstanding:</span>
                  <span className="ml-2 font-semibold text-red-600">
                    {parseFloat(selectedSupplier?.outstanding || 0).toFixed(3)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Header>
  );
};

export default ApReportTable;